import { useMemo } from 'react';

/**
 * Single instance per component tree — prefer over `new SomeService()` in render.
 */
export function useService<T>(ServiceClass: new () => T): T {
  return useMemo(() => new ServiceClass(), [ServiceClass]);
}